import React from 'react';

import { Button, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const Footer = ({
    disabled,
    canDelete,
    control,
    filterData,
    handleClickBulkItems,
    onClick,
    setValue,
}) => {
    const { t } = useTranslation();
    const [productId, statusFlag] = useWatch({
        control,
        name: ['id', 'status_flag'],
    });
    const isNewRecord = !productId;
    const isArchived = statusFlag === 'archived';

    if (disabled) return null;

    return (
        <Grid container sx={{ mt: 2 }}>
            <Grid
                size="grow"
                sx={{
                    display: 'flex',
                    flexDirection: { md: 'row', xs: 'column' },
                    gap: 2,
                    justifyContent: { md: 'right', xs: 'center' },
                }}
            >
                {!isNewRecord && (
                    <>
                        <Button
                            color="secondary"
                            disabled={disabled}
                            onClick={() =>
                                handleClickBulkItems(
                                    [productId],
                                    'archived',
                                    filterData,
                                    () => setValue('status_flag', 'archived'),
                                )
                            }
                            sx={{
                                order: { md: 1, xs: 2 },
                                width: { md: 'auto', xs: '100%' },
                            }}
                            type="button"
                            variant="text"
                            visible={!isArchived && canDelete}
                        >
                            {t('Archive')}
                        </Button>

                        <Button
                            color="secondary"
                            disabled={disabled}
                            onClick={() =>
                                handleClickBulkItems(
                                    [productId],
                                    'active',
                                    filterData,
                                    () => setValue('status_flag', 'active'),
                                )
                            }
                            sx={{
                                order: { md: 1, xs: 2 },
                                width: { md: 'auto', xs: '100%' },
                            }}
                            type="button"
                            variant="text"
                            visible={isArchived && canDelete}
                        >
                            {t('Restore')}
                        </Button>

                        <Button
                            color="error"
                            onClick={() =>
                                handleClickBulkItems(
                                    [productId],
                                    'deleted',
                                    filterData,
                                    () => {},
                                )
                            }
                            sx={{
                                order: { md: 1, xs: 2 },
                                width: { md: 'auto', xs: '100%' },
                            }}
                            type="button"
                            variant="text"
                            visible={isArchived && canDelete}
                        >
                            {t('Delete')}
                        </Button>
                    </>
                )}

                <Button
                    onClick={onClick}
                    sx={{
                        order: { md: 2, xs: 1 },
                        width: { md: 'auto', xs: '100%' },
                    }}
                    type="button"
                    variant="outlined"
                    visible={!isArchived}
                >
                    {isNewRecord ? t('Create') : t('Save')}
                </Button>
            </Grid>
        </Grid>
    );
};

Footer.propTypes = {
    disabled: PropTypes.bool,
    canDelete: PropTypes.bool,
    control: PropTypes.object,
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    onClick: PropTypes.func,
    setValue: PropTypes.func,
};

export default Footer;
